import { CSSProperties, FC, ReactNode, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import classes from './ScrollingTitle.module.css';

interface ScrollingTitleProps {
    children: ReactNode;
    style?: CSSProperties;
    className?: string;
}

export const ScrollingTitle: FC<ScrollingTitleProps> = ({ children, style, className }) => {
    const ref = useRef<HTMLDivElement>(null);
    const [width, setWidth] = useState(0);

    useEffect(() => {
        if (!ref.current) return;

        const w = ref.current.offsetWidth;
        setWidth(w);
    }, [children]);

    return (
        <div className={classNames(classes['scrolling-title'], className)} style={{ ...style, width: `${width}px` }}>
            <div ref={ref}>{children}</div>
            <div>{children}</div>
            <div>{children}</div>
        </div>
    );
};
